import React, { useEffect } from 'react';
import './App.css';
import Hero from './components/Hero';
import AboutMe from './components/AboutMe';
import Tech from './components/Tech';
import Certificates from './components/Certificates';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollToTopButton from './components/ScrollToTopButton';
// import Chat from './components/Chat';

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className='app-shell'>
      <div className='content-shell font-sans overflow-x-hidden'>
        {/* <Chat /> */}
        <Hero />
        <AboutMe />
        <Tech />
        <Certificates />
        <Projects />
        <Contact />
        <Footer />
        <ScrollToTopButton />
      </div>
    </div>
  );
};

export default App;
